<template>
  <div class="report-item" v-if="!edition"><!--2023-12-26 贾志海要求隐藏-->
    <img class="icon" :src="icon" alt="">
    <p class="icon-title">{{ iconTitle }}</p>
    <img v-if="edition" class="report-tag" :src="tag" alt="">
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: 'ReportIcon'
})
</script>

<script lang="ts" setup>
import { computed, defineProps, PropType, ref } from "vue";
import { useReportCenterIcon } from './index'
import { EditionType } from '../../download/download.interface'
import tagValueAdded from '@/assets/images/tag-valueAdded.png'
import tagEnhanced from '@/assets/images/tag-enhanced.png'
import {IsZhiHuiXingHe} from "@/core/hooks/SetTheme"
const reportCenterMap = useReportCenterIcon()

const props = defineProps({
  iconName: {
    type: String,
    required: true
  },
  iconTitle: {
    type: String,
    required: true
  },
  link: {
    type: String,
    default: ''
  },
  edition: {
    // enhanced --> 加强版 valueAdded--> 增值版
    type: String as PropType<EditionType>,
    default: ''
  }
})

const icon = reportCenterMap?.[props.iconName+(IsZhiHuiXingHe()?'-green':'')] || ''


const tag = computed(() => {
  if(props.edition === 'valueAdded') return tagValueAdded
  if(props.edition === 'enhanced') return tagEnhanced
})

</script>

<style lang="less">
.report-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100px;
  position: relative;
  &:hover {
    cursor: pointer;
  }
  .icon {
    width: 60px;
    height: 60px;
  }
  .icon-title {
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    line-height: 22px;
    font-size: 14px;
    letter-spacing: 0;
    margin-bottom: 16px;
  }
  .report-tag {
    position: absolute;
    bottom: 43px;
    right: -2px;
    width: 48px;
    height: 22px;
  }
}
</style>
